import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Solutions from "@/pages/Solutions";

export const Route = createFileRoute("/en/solutions/")({
  head: () => buildRouteHead("/en/solutions"),
  component: Solutions,
});

